/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resources_Productionlabo_Name1Inputs */

const en_resources_productionlabo_name1 = /** @type {(inputs: Resources_Productionlabo_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lab - Diamant Range`)
};

const fr_resources_productionlabo_name1 = /** @type {(inputs: Resources_Productionlabo_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Labo - Gamme Diamant`)
};

const es_resources_productionlabo_name1 = /** @type {(inputs: Resources_Productionlabo_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laboratorio - Gama Diamant`)
};

const de_resources_productionlabo_name1 = /** @type {(inputs: Resources_Productionlabo_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Labor - Diamant Sortiment`)
};

const nl_resources_productionlabo_name1 = /** @type {(inputs: Resources_Productionlabo_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lab - Diamant Gamma`)
};

/**
* | output |
* | --- |
* | "Lab - Diamant Range" |
*
* @param {Resources_Productionlabo_Name1Inputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "de" | "nl" }} options
* @returns {LocalizedString}
*/
const resources_productionlabo_name1 = /** @type {((inputs?: Resources_Productionlabo_Name1Inputs, options?: { locale?: "en" | "fr" | "es" | "de" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resources_Productionlabo_Name1Inputs, { locale?: "en" | "fr" | "es" | "de" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_resources_productionlabo_name1(inputs)
	if (locale === "fr") return fr_resources_productionlabo_name1(inputs)
	if (locale === "es") return es_resources_productionlabo_name1(inputs)
	if (locale === "de") return de_resources_productionlabo_name1(inputs)
	return nl_resources_productionlabo_name1(inputs)
});
export { resources_productionlabo_name1 as "resources.productionLabo.name" }